import { motion } from "framer-motion";
import { revealProps } from "../../../utils/motion";

/**
 * Envuelve contenido para animarlo suavemente cuando entra en el viewport.
 * Uso: <Reveal delay={0.1}>...</Reveal>
 */
const Reveal = ({ children, delay = 0, y = 28, as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag {...revealProps(delay, y)} {...rest}>
      {children}
    </MotionTag>
  );
};

export default Reveal;
